var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuhyeop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_Sh\xE1\x84\x89\xE1\x85\xAE\xE1\x84\x92\xE1\x85\xA7\xE1\x86\xB8 1",
    clipPath: "url(#clip0_1736_10088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "#0068B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.04382 11.9961C10.6629 13.0372 10.8198 13.9689 10.4718 14.7369C10.3278 15.0576 10.0236 15.3369 10.0236 15.3369C10.0236 15.3369 11.3978 14.6741 11.8327 13.7049C12.3189 12.6225 11.7923 11.4763 10.3196 10.4827C9.0996 9.6605 9.60649 8.88273 9.60649 8.88273C9.60649 8.88273 10.0087 7.85806 11.5109 7.8585C13.0469 7.8585 13.1603 8.89139 13.1603 8.89139L13.7603 7.7025C13.8443 7.51517 12.7825 6.98873 11.256 6.98828C9.75316 6.98828 8.36716 7.5925 7.82693 8.79628C7.16649 10.2663 8.00471 11.3289 9.04382 11.9961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9223 13.6613C19.1332 13.07 20.3361 10.0973 18.2663 10.0969C16.8536 10.0969 15.2552 11.2051 15.2552 11.2051L16.6578 7.94109C16.6578 7.94109 17.0461 7.15865 16.1485 7.1582H14.7023C14.7023 7.1582 15.2389 7.36998 14.7647 8.42643L12.6729 13.1909C12.6729 13.1909 11.4854 15.7671 9.09695 15.7666C5.95339 15.7666 6.19673 12.5722 6.19673 12.5722L5.06006 15.0806C5.06006 15.0806 6.07628 17.0118 8.56161 17.0122C10.0645 17.0122 11.0178 16.3786 11.4809 15.8789C11.4809 15.8789 11.0323 16.9233 12.2227 16.9233H13.4449C13.4449 16.9233 13.1007 16.6833 13.1263 16.3791C13.1518 16.0749 13.5607 15.1138 13.8374 14.6106C14.1141 14.1075 15.4847 11.6666 17.0821 11.5133C18.5221 11.3755 16.3521 15.8986 16.3521 15.8986C16.3521 15.8986 15.9329 16.8778 17.0216 16.9066C18.1103 16.9355 18.3105 16.9344 18.3105 16.9344C18.3105 16.9344 17.9009 16.6282 18.1032 16.0704C18.3054 15.5126 18.7112 14.2531 18.9223 13.6613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_10088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuhyeop);
export default __webpack_public_path__ + "static/media/suhyeop.e1131020434b008ba4654b688d1b82a3.svg";
export { ForwardRef as ReactComponent };